import { FileImage } from "lucide-react";
import { Link } from "@/lib/nav";
import { useTransition } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { settleRedirect } from "@/lib/redirect-error";
import { createPortfolioFromProject } from "@/api/actions/portfolio";

interface Props {
  projectId: string;
  // 이미 만든 초안 — 있으면 만들지 않고 연다.
  portfolioId: string | null;
  // 닫힌 현장에서는 이 버튼이 머리줄의 주 버튼이다.
  primary?: boolean;
}

// 준공한 현장의 「시공사례 초안 만들기/열기」 — 만들면 액션이 편집 화면으로 보낸다.
const PortfolioDraftButton = ({ projectId, portfolioId, primary = false }: Props) => {
  const variant = primary ? "primary" : "outline";
  const [pending, startTransition] = useTransition();

  if (portfolioId) {
    return (
      <Button asChild data-testid="project-portfolio-open" size="sm" variant={variant}>
        <Link href={`/app/portfolio/${portfolioId}`}>
          <FileImage className="size-4" />
          시공사례 초안 열기
        </Link>
      </Button>
    );
  }

  const create = () =>
    startTransition(async () => {
      try {
        const result = await createPortfolioFromProject(projectId);
        if (result?.ok === false) toast.error(result.message);
      } catch (error) {
        if (settleRedirect(error)) return;
        toast.error("시공사례 초안을 만들지 못했습니다");
      }
    });

  return (
    <Button data-testid="project-portfolio-create" disabled={pending} size="sm" type="button" variant={variant} onClick={create}>
      <FileImage className="size-4" />
      시공사례 초안 만들기
    </Button>
  );
};

export default PortfolioDraftButton;
